<template>
  <div class="mianzheng">
    <img src="../../assets/img/2_02.png" />
    <div class="time">{{ time }} s</div>
  </div>
</template>

<script>
import cookie from "@utils/store/cookie";
export default {
  name: "mianzheng",
  data() {
    return {
      time: 5
    };
  },
  mounted() {
    cookie.remove("saveData");
    cookie.remove("pid");
    cookie.remove("secret_key");
    cookie.set("pid", this.$route.query.id);
    cookie.set("secret_key", this.$route.query.secret_key);
    // se(() => {
    //   this.$router.replace({ path: "/mianzheng/list" });
    // }, 5000);
    let timer = window.setInterval(() => {
      this.time--;
      if (this.time < 0) {
        window.clearInterval(timer);
        this.$router.replace({ path: "/mianzheng/list" });
      }
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.mianzheng {
  font-size: 0;
  height: 100vh;
  background-image: url("../../assets/img/mianzheng.png");
  background-size: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
  position: relative;
  img {
    position: absolute;
    width: 100%;
    bottom: 0.1rem;
  }
  .time {
    position: fixed;
    top: 0.3rem;
    right: 0.3rem;
    font-size: 0.28rem;
    line-height: 0.32rem;
    background: #f5f5f5;
    border-radius: 0.14rem;
    width: 0.8rem;
    text-align: center;
  }
}
</style>
